import xeroLogo from '../../../../../../assets/images/logo-xero.svg';
import { Button } from '../../../../../../design-system/button/button';
import { Stack } from '../../../../../../design-system/stack/stack';

type XeroConnectedModalContentProps = {
  onClose: () => void;
};

export const XeroConnectedModalContent = ({ onClose }: XeroConnectedModalContentProps) => {
  return (
    <Stack space={10} align="center">
      <Stack space={3} align="center">
        <div className="h-16 w-16 rounded-full">
          <img
            src={xeroLogo}
            alt="Xero Logo"
            loading="eager"
            fetchpriority="high"
            className="h-full w-full object-contain"
          />
        </div>

        <Stack space={1} align="center">
          <h1 className="text-xl leading-7 font-medium tracking-tight text-black">You're connected to Xero</h1>

          <p className="text-center text-base leading-5 font-medium tracking-tight text-muted-foreground">
            Your accounts are now connected. From now on invoices paid through Seapoint will flow directly into Xero.
          </p>
        </Stack>
      </Stack>

      <Button variant="default" onClick={onClose} className="w-full">
        Great, let's go
      </Button>
    </Stack>
  );
};
